import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "graph" */ './graph')
);

const GraphLoader = props => <LoadableComponent {...props} />;

export default GraphLoader;
